import { environment } from "../../environments/environment";

export const NOTIFICATIONS = [
  {
    id: 8305,
    created_at: '9 days ago',
    title: 'Approved request',
    message: 'Your request for testdata has been approved. Please check.',
    table_reference: 'request',
    read_status: false,
    user_id: 2,
    recieved_to: 2,
    extra_events: '',
    created_at_timeStamp: 1706696232116,
    isYesterday: 3,
  },
  {
    id: 8189,
    created_at: '9 days ago',
    title: 'Approved request',
    message: 'Your request for Lcd has been approved. Please check.',
    table_reference: 'request',
    read_status: false,
    user_id: 2,
    recieved_to: 2,
    extra_events: '',
    created_at_timeStamp: 1706691332449,
    isYesterday: 4,
  },
  {
    id: 8188,
    created_at: '10 days ago',
    title: 'Approved request',
    message: 'Your request for sss has been approved. Please check.',
    table_reference: 'request',
    read_status: false,
    user_id: 2,
    recieved_to: 2,
    extra_events: '',
    created_at_timeStamp: 1706628236353,
    isYesterday: 5,
  },
  {
    id: 7744,
    created_at: '16 days ago',
    title: 'Approved request',
    message: 'Your request for Lcd has been approved. Please check.',
    table_reference: 'request',
    read_status: true,
    user_id: 2,
    recieved_to: 2,
    extra_events: '',
    created_at_timeStamp: 1706091265027,
    isYesterday: 6,
  },
  {
    id: 6888,
    created_at: '23 days ago',
    title: 'Approved request',
    message: 'Your request for sss has been approved. Please check.',
    table_reference: 'request',
    read_status: true,
    user_id: 2,
    recieved_to: 2,
    extra_events: '',
    created_at_timeStamp: 1705474151906,
    isYesterday: 7,
  },
  {
    id: 6536,
    created_at: 'a month ago',
    title: 'You have a new message',
    message: 'You have new message from jake johnson. Check now.',
    table_reference: 'messages',
    read_status: true,
    user_id: 2,
    recieved_to: 2,
    extra_events: '',
    created_at_timeStamp: 1704435404539,
    isYesterday: 8,
  },
  {
    id: 6535,
    created_at: 'a month ago',
    title: 'You have a new message',
    message: 'You have new message from jake johnson. Check now.',
    table_reference: 'messages',
    read_status: true,
    user_id: 2,
    recieved_to: 2,
    extra_events: '',
    created_at_timeStamp: 1704434901533,
    isYesterday: 9,
  },
  {
    id: 9004,
    created_at: '4 days ago',
    title: 'New Request',
    message: 'You have got a new request. Check now.',
    table_reference: 'request',
    read_status: false,
    user_id: 3,
    recieved_to: 234,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 7,
  },
  {
    id: 9005,
    created_at: '5 days ago',
    title: 'Urgent Notification',
    message: 'An urgent notification for you. Check now.',
    table_reference: 'notification',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 8,
  },
  {
    id: 9006,
    created_at: '6 days ago',
    title: 'Meeting Reminder',
    message: 'Reminder: You have a meeting scheduled. Check now.',
    table_reference: 'reminder',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 9,
  },
  {
    id: 9007,
    created_at: '7 days ago',
    title: 'Feedback Request',
    message: 'You have a pending feedback request. Check now.',
    table_reference: 'feedback',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 10,
  },
  {
    id: 9008,
    created_at: '8 days ago',
    title: 'New Task Assigned',
    message: 'A new task has been assigned to you. Check now.',
    table_reference: 'task',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 11,
  },
  {
    id: 9009,
    created_at: '9 days ago',
    title: 'System Update',
    message: 'Important: System update scheduled. Check now.',
    table_reference: 'update',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 12,
  },
  {
    id: 9010,
    created_at: '10 days ago',
    title: 'Birthday Reminder',
    message: "It's someone's birthday today. Check now.",
    table_reference: 'birthday',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 13,
  },
  {
    id: 9011,
    created_at: '11 days ago',
    title: 'New Announcement',
    message: 'A new announcement has been made. Check now.',
    table_reference: 'announcement',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 14,
  },
  {
    id: 9012,
    created_at: '12 days ago',
    title: 'Weather Update',
    message: 'Weather update: Rain expected. Check now.',
    table_reference: 'weather',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 15,
  },
  {
    id: 9013,
    created_at: '13 days ago',
    title: 'Training Session',
    message: 'Upcoming training session. Check now for details.',
    table_reference: 'training',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 16,
  },
];
export const UNREAD_NOTIFICATIONS = [
  {
    id: 8430,
    created_at: '7 days ago',
    title: 'You have got a new request',
    message: 'You have got new request from Ellyse Perry. Check now.',
    table_reference: 'request',
    read_status: false,
    user_id: 235,
    recieved_to: 234,
    extra_events: '',
    created_at_timeStamp: 1706861683560,
    isYesterday: 1,
  },
  {
    id: 8314,
    created_at: '8 days ago',
    title: 'You have got a new request',
    message: 'You have got new request from Randy Ortan. Check now.',
    table_reference: 'request',
    read_status: false,
    user_id: 2,
    recieved_to: 234,
    extra_events: '',
    created_at_timeStamp: 1706779576401,
    isYesterday: 2,
  },
  {
    id: 8191,
    created_at: '9 days ago',
    title: 'You have got a new request',
    message: 'You have got new request from Randy Ortan. Check now.',
    table_reference: 'request',
    read_status: false,
    user_id: 2,
    recieved_to: 234,
    extra_events: '',
    created_at_timeStamp: 1706692334442,
    isYesterday: 3,
  },
  {
    id: 9001,
    created_at: '1 day ago',
    title: 'New Notification',
    message: 'This is a new notification. Check now.',
    table_reference: 'notification',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 4,
  },
  {
    id: 9002,
    created_at: '2 days ago',
    title: 'Another Notification',
    message: 'Another notification for you. Check now.',
    table_reference: 'notification',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 5,
  },
  {
    id: 9003,
    created_at: '3 days ago',
    title: 'Important Notification',
    message: 'An important notification. Check now.',
    table_reference: 'notification',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 6,
  },
  {
    id: 9004,
    created_at: '4 days ago',
    title: 'New Request',
    message: 'You have got a new request. Check now.',
    table_reference: 'request',
    read_status: false,
    user_id: 3,
    recieved_to: 234,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 7,
  },
  {
    id: 9005,
    created_at: '5 days ago',
    title: 'Urgent Notification',
    message: 'An urgent notification for you. Check now.',
    table_reference: 'notification',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 8,
  },
  {
    id: 9006,
    created_at: '6 days ago',
    title: 'Meeting Reminder',
    message: 'Reminder: You have a meeting scheduled. Check now.',
    table_reference: 'reminder',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 9,
  },
  {
    id: 9007,
    created_at: '7 days ago',
    title: 'Feedback Request',
    message: 'You have a pending feedback request. Check now.',
    table_reference: 'feedback',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 10,
  },
  {
    id: 9008,
    created_at: '8 days ago',
    title: 'New Task Assigned',
    message: 'A new task has been assigned to you. Check now.',
    table_reference: 'task',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 11,
  },
  {
    id: 9009,
    created_at: '9 days ago',
    title: 'System Update',
    message: 'Important: System update scheduled. Check now.',
    table_reference: 'update',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 12,
  },
  {
    id: 9010,
    created_at: '10 days ago',
    title: 'Birthday Reminder',
    message: "It's someone's birthday today. Check now.",
    table_reference: 'birthday',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 13,
  },
  {
    id: 9011,
    created_at: '11 days ago',
    title: 'New Announcement',
    message: 'A new announcement has been made. Check now.',
    table_reference: 'announcement',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 14,
  },
  {
    id: 9012,
    created_at: '12 days ago',
    title: 'Weather Update',
    message: 'Weather update: Rain expected. Check now.',
    table_reference: 'weather',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 15,
  },
  {
    id: 9013,
    created_at: '13 days ago',
    title: 'Training Session',
    message: 'Upcoming training session. Check now for details.',
    table_reference: 'training',
    read_status: false,
    user_id: 1,
    recieved_to: 1,
    extra_events: '',
    created_at_timeStamp: Date.now(),
    isYesterday: 16,
  },
];

export const DISABLED_USERS = [
  {
    id: 249,
    created_at: 1691065485514,
    firstName: 'Jeck',
    lastName: 'Jerry',
    email: 'jeck@teacher.com',
    school_indentity_number: '',
    role_id: 9,
    school_id: 47,
    isNewUser: false,
    profileData: {
      dateOfHire: 1691046000000,
      currentRoute: '/administration',
      tbClearanceDate: 1690959600000,
      tbExpirationDate: 1817190000000,
      credentialDocumentNumber: '2121873827777',
      credentialExpirationDate: 1692082800000,
      credentialTypeEmployment: 'teacher',
      dateOfCriminalBackground: 1690959600000,
    },
    teachingInfo: {
      bellShedule: 'true',
      designation: 'Highschool',
      examPerdays: 14,
      teachingGrades: [8, 9, 10, 12, 11, 13],
      teachingSubject: [7, 8, 6, 4, 5],
      teachingSubjectcount: 5,
    },
    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: 1557903600000,
    isDisable: true,
    is_logged_in: false,
    is_trial_user: null,
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },
  {
    id: 3737,
    created_at: 1698935925926,
    firstName: 'Kevin',
    lastName: 'Owens',
    email: 'kevin@teacher.com',
    school_indentity_number: 'kevin12342',
    role_id: 9,
    school_id: 47,
    isNewUser: false,
    profileData: {
      dateOfHire: 1699948800000,
      currentRoute: '/test-quizzes',
      tbClearanceDate: 1698908400000,
      tbExpirationDate: 1825138800000,
      credentialDocumentNumber: '3982983898',
      credentialExpirationDate: 1699344000000,
      credentialTypeEmployment: 'Teacher',
      dateOfCriminalBackground: 1699516800000,
    },
    teachingInfo: {
      bellShedule: 'true',
      designation: 'Highschool',
      examPerdays: 9,
      teachingGrades: [8, 9, 10, 11, 12, 13, 14],
      teachingSubject: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 18, 19, 20, 21, 22,
        23, 24, 25, 26, 27,
      ],
      schoolBellScheduleId: 105,
      teachingSubjectcount: 25,
    },
    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: 1572591600000,
    isDisable: true,
    is_logged_in: false,
    is_trial_user: null,
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },
  {
    id: 802,
    created_at: 1692708528499,
    firstName: 'Linda',
    lastName: 'Winona',
    email: 'linda@teacher.com',
    school_indentity_number: '789654345675',
    role_id: 9,
    school_id: 47,
    isNewUser: false,
    profileData: {
      dateOfHire: 1278979200000,
      currentRoute: '/administration',
      tbClearanceDate: 1290038400000,
      tbExpirationDate: 1416268800000,
      credentialDocumentNumber: '646463738',
      credentialExpirationDate: 1658361600000,
      credentialTypeEmployment: 'Multiple',
      dateOfCriminalBackground: 1247616000000,
    },
    teachingInfo: {
      bellShedule: 'true',
      designation: 'Elementary',
      examPerdays: 10,
      teachingGrades: [3, 4, 5, 6, 7],
      teachingSubject: [1, 2, 5, 6, 7, 3, 4, 8, 9, 10],
      teachingSubjectcount: 10,
    },
    user_profile_media_id: 0,
    contact: 5345353535,
    address: 'california',
    birthdate: 969778800000,
    isDisable: true,
    is_logged_in: false,
    is_trial_user: null,
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },
  {
    id: 1201,
    created_at: 1695748601592,
    firstName: 'Alice',
    lastName: 'Johnson',
    email: 'alice@teacher.com',
    school_indentity_number: '987654321',
    role_id: 9,
    school_id: 47,
    isNewUser: false,
    profileData: {
      dateOfHire: 1695840000000,
      currentRoute: '/test-quizzes',
      tbClearanceDate: 1695776000000,
      tbExpirationDate: 1822006400000,
      credentialDocumentNumber: '87654321',
      credentialExpirationDate: 1696208000000,
      credentialTypeEmployment: 'Teacher',
      dateOfCriminalBackground: 1695867600000,
    },
    teachingInfo: {
      bellShedule: 'true',
      designation: 'Middle School',
      examPerdays: 8,
      teachingGrades: [6, 7, 8, 9],
      teachingSubject: [1, 2, 3, 4, 5, 6, 7, 8],
      teachingSubjectcount: 8,
    },
    user_profile_media_id: 0,
    contact: 9876543210,
    address: 'New York',
    birthdate: 1609459200000,
    isDisable: true,
    is_logged_in: false,
    is_trial_user: null,
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },
  {
    id: 1357,
    created_at: 1696807943143,
    firstName: 'David',
    lastName: 'Smith',
    email: 'david@teacher.com',
    school_indentity_number: '876543210',
    role_id: 9,
    school_id: 47,
    isNewUser: false,
    profileData: {
      dateOfHire: 1696924800000,
      currentRoute: '/administration',
      tbClearanceDate: 1696860800000,
      tbExpirationDate: 1823099200000,
      credentialDocumentNumber: '98765432',
      credentialExpirationDate: 1697347200000,
      credentialTypeEmployment: 'Teacher',
      dateOfCriminalBackground: 1697016000000,
    },
    teachingInfo: {
      bellShedule: 'true',
      designation: 'High School',
      examPerdays: 10,
      teachingGrades: [10, 11, 12],
      teachingSubject: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
      teachingSubjectcount: 10,
    },
    user_profile_media_id: 0,
    contact: 8765432109,
    address: 'California',
    birthdate: 1514784000000,
    isDisable: true,
    is_logged_in: false,
    is_trial_user: null,
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },
  {
    id: 249,
    created_at: 1691065485514,
    firstName: 'Jeck',
    lastName: 'Jerry',
    email: 'jeck@teacher.com',
    school_indentity_number: '',
    role_id: 9,
    school_id: 47,
    isNewUser: false,
    profileData: {
      dateOfHire: 1691046000000,
      currentRoute: '/administration',
      tbClearanceDate: 1690959600000,
      tbExpirationDate: 1817190000000,
      credentialDocumentNumber: '2121873827777',
      credentialExpirationDate: 1692082800000,
      credentialTypeEmployment: 'teacher',
      dateOfCriminalBackground: 1690959600000,
    },
    teachingInfo: {
      bellShedule: 'true',
      designation: 'Highschool',
      examPerdays: 14,
      teachingGrades: [8, 9, 10, 12, 11, 13],
      teachingSubject: [7, 8, 6, 4, 5],
      teachingSubjectcount: 5,
    },
    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: 1557903600000,
    isDisable: true,
    is_logged_in: false,
    is_trial_user: null,
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },
  {
    id: 3737,
    created_at: 1698935925926,
    firstName: 'Kevin',
    lastName: 'Owens',
    email: 'kevin@teacher.com',
    school_indentity_number: 'kevin12342',
    role_id: 9,
    school_id: 47,
    isNewUser: false,
    profileData: {
      dateOfHire: 1699948800000,
      currentRoute: '/test-quizzes',
      tbClearanceDate: 1698908400000,
      tbExpirationDate: 1825138800000,
      credentialDocumentNumber: '3982983898',
      credentialExpirationDate: 1699344000000,
      credentialTypeEmployment: 'Teacher',
      dateOfCriminalBackground: 1699516800000,
    },
    teachingInfo: {
      bellShedule: 'true',
      designation: 'Highschool',
      examPerdays: 9,
      teachingGrades: [8, 9, 10, 11, 12, 13, 14],
      teachingSubject: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 18, 19, 20, 21, 22,
        23, 24, 25, 26, 27,
      ],
      schoolBellScheduleId: 105,
      teachingSubjectcount: 25,
    },
    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: 1572591600000,
    isDisable: true,
    is_logged_in: false,
    is_trial_user: null,
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },
  {
    id: 802,
    created_at: 1692708528499,
    firstName: 'Linda',
    lastName: 'Winona',
    email: 'linda@teacher.com',
    school_indentity_number: '789654345675',
    role_id: 9,
    school_id: 47,
    isNewUser: false,
    profileData: {
      dateOfHire: 1278979200000,
      currentRoute: '/administration',
      tbClearanceDate: 1290038400000,
      tbExpirationDate: 1416268800000,
      credentialDocumentNumber: '646463738',
      credentialExpirationDate: 1658361600000,
      credentialTypeEmployment: 'Multiple',
      dateOfCriminalBackground: 1247616000000,
    },
    teachingInfo: {
      bellShedule: 'true',
      designation: 'Elementary',
      examPerdays: 10,
      teachingGrades: [3, 4, 5, 6, 7],
      teachingSubject: [1, 2, 5, 6, 7, 3, 4, 8, 9, 10],
      teachingSubjectcount: 10,
    },
    user_profile_media_id: 0,
    contact: 5345353535,
    address: 'california',
    birthdate: 969778800000,
    isDisable: true,
    is_logged_in: false,
    is_trial_user: null,
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },
];

export const STUDENT_TRANSFER_DATA = [
  {
    id: 3,
    created_at: 1697032240459,
    user_id: 1666,
    current_school_id: 47,
    new_school_id: 1,
    status: 'pending',
    user: {
      id: 1666,
      firstName: 'Jenny',
      lastName: 'Smith',
      email: 'jenny@student.com',
      user_profile_media_id: 0,
    },
    new_school: {
      id: 1,
      name: 'International Academy',
      code: 'O4TAvLFC',
    },
  },
  {
    id: 7,
    created_at: 1697116682775,
    user_id: 1666,
    current_school_id: 47,
    new_school_id: 47,
    status: 'pending',
    user: {
      id: 1666,
      firstName: 'Jenny',
      lastName: 'Smith',
      email: 'jenny@student.com',
      user_profile_media_id: 0,
    },
    new_school: {
      id: 47,
      name: 'Wipro International School',
      code: 'GzE1oY4x',
    },
  },
  {
    id: 9,
    created_at: 1697438454075,
    user_id: 1666,
    current_school_id: 47,
    new_school_id: 47,
    status: 'rejected',
    user: {
      id: 1666,
      firstName: 'Jenny',
      lastName: 'Smith',
      email: 'jenny@student.com',
      user_profile_media_id: 0,
    },
    new_school: {
      id: 47,
      name: 'Wipro International School',
      code: 'GzE1oY4x',
    },
  },
  {
    id: 1,
    created_at: 1697007002381,
    user_id: 1666,
    current_school_id: 47,
    new_school_id: 47,
    status: 'approved',
    user: {
      id: 1666,
      firstName: 'Jenny',
      lastName: 'Smith',
      email: 'jenny@student.com',
      user_profile_media_id: 0,
    },
    new_school: {
      id: 47,
      name: 'Wipro International School',
      code: 'GzE1oY4x',
    },
  },
  {
    id: 4,
    created_at: 1697032240459,
    user_id: 1777,
    current_school_id: 47,
    new_school_id: 2,
    status: 'approved',
    user: {
      id: 1777,
      firstName: 'John',
      lastName: 'Doe',
      email: 'john@student.com',
      user_profile_media_id: 0,
    },
    new_school: {
      id: 2,
      name: 'City High School',
      code: 'X8YBpRQW',
    },
  },
  {
    id: 5,
    created_at: 1697032240459,
    user_id: 1888,
    current_school_id: 47,
    new_school_id: 3,
    status: 'rejected',
    user: {
      id: 1888,
      firstName: 'Emily',
      lastName: 'Johnson',
      email: 'emily@student.com',
      user_profile_media_id: 0,
    },
    new_school: {
      id: 3,
      name: 'Highland Elementary',
      code: 'Z9uCmSJK',
    },
  },
  {
    id: 11,
    created_at: 1697032240459,
    user_id: 1999,
    current_school_id: 47,
    new_school_id: 4,
    status: 'pending',
    user: {
      id: 1999,
      firstName: 'Michael',
      lastName: 'Williams',
      email: 'michael@student.com',
      user_profile_media_id: 0,
    },
    new_school: {
      id: 4,
      name: 'Central High School',
      code: 'P5RwN3LQ',
    },
  },
  {
    id: 12,
    created_at: 1697032240459,
    user_id: 2111,
    current_school_id: 47,
    new_school_id: 5,
    status: 'pending',
    user: {
      id: 2111,
      firstName: 'Sophia',
      lastName: 'Anderson',
      email: 'sophia@student.com',
      user_profile_media_id: 0,
    },
    new_school: {
      id: 5,
      name: 'Westside Elementary',
      code: 'T2UxV9YR',
    },
  },
  {
    id: 13,
    created_at: 1697032240459,
    user_id: 2222,
    current_school_id: 47,
    new_school_id: 6,
    status: 'pending',
    user: {
      id: 2222,
      firstName: 'David',
      lastName: 'Miller',
      email: 'david@student.com',
      user_profile_media_id: 0,
    },
    new_school: {
      id: 6,
      name: 'Eastwood High',
      code: 'U7QpM1ZS',
    },
  },
  {
    id: 14,
    created_at: 1697032240459,
    user_id: 2333,
    current_school_id: 47,
    new_school_id: 7,
    status: 'pending',
    user: {
      id: 2333,
      firstName: 'Olivia',
      lastName: 'Brown',
      email: 'olivia@student.com',
      user_profile_media_id: 0,
    },
    new_school: {
      id: 7,
      name: 'Northside Middle School',
      code: 'V8XyU2ZQ',
    },
  },
  {
    id: 15,
    created_at: 1697032240459,
    user_id: 2444,
    current_school_id: 47,
    new_school_id: 8,
    status: 'pending',
    user: {
      id: 2444,
      firstName: 'Aiden',
      lastName: 'Taylor',
      email: 'aiden@student.com',
      user_profile_media_id: 0,
    },
    new_school: {
      id: 8,
      name: 'South Elementary',
      code: 'W9ZaB3ZR',
    },
  },
  {
    id: 16,
    created_at: 1697032240459,
    user_id: 2555,
    current_school_id: 47,
    new_school_id: 9,
    status: 'pending',
    user: {
      id: 2555,
      firstName: 'Emma',
      lastName: 'Clark',
      email: 'emma@student.com',
      user_profile_media_id: 0,
    },
    new_school: {
      id: 9,
      name: 'West Middle School',
      code: 'X1YbZ4AS',
    },
  },
  {
    id: 17,
    created_at: 1697032240459,
    user_id: 2666,
    current_school_id: 47,
    new_school_id: 10,
    status: 'pending',
    user: {
      id: 2666,
      firstName: 'Liam',
      lastName: 'White',
      email: 'liam@student.com',
      user_profile_media_id: 0,
    },
    new_school: {
      id: 10,
      name: 'East Elementary',
      code: 'Y2ZcA5BT',
    },
  },
  {
    id: 18,
    created_at: 1697032240459,
    user_id: 2777,
    current_school_id: 47,
    new_school_id: 11,
    status: 'pending',
    user: {
      id: 2777,
      firstName: 'Ella',
      lastName: 'Green',
      email: 'ella@student.com',
      user_profile_media_id: 0,
    },
    new_school: {
      id: 11,
      name: 'Central Middle School',
      code: 'Z3CdA6CU',
    },
  },
  {
    id: 19,
    created_at: 1697032240459,
    user_id: 2888,
    current_school_id: 47,
    new_school_id: 12,
    status: 'pending',
    user: {
      id: 2888,
      firstName: 'Noah',
      lastName: 'Hill',
      email: 'noah@student.com',
      user_profile_media_id: 0,
    },
    new_school: {
      id: 12,
      name: 'South Middle School',
      code: 'A4DeB7CX',
    },
  },
  {
    id: 20,
    created_at: 1697032240459,
    user_id: 2999,
    current_school_id: 47,
    new_school_id: 13,
    status: 'pending',
    user: {
      id: 2999,
      firstName: 'Mia',
      lastName: 'Davis',
      email: 'mia@student.com',
      user_profile_media_id: 0,
    },
    new_school: {
      id: 13,
      name: 'West Elementary',
      code: 'B5EfC8CY',
    },
  },
];

export const MANAGE_USER_DATA = [
  {
    id: 3833,
    created_at: 1707319499456,
    isArchived: true,
    firstName: 'Sam',
    lastName: 'Patrick',
    email: 'same.p@teacher.com',
    school_indentity_number: 'george451236',
    role_id: 9,
    school_id: 47,
    isNewUser: false,
    profileData: {
      dateOfHire: 1704911400000,
      currentRoute: '/administration',
      tbClearanceDate: 1704652200000,
      tbExpirationDate: 1830882600000,
      credentialDocumentNumber: '1458326578975',
      credentialExpirationDate: 1718303400000,
      credentialTypeEmployment: 'None',
      dateOfCriminalBackground: 1704738600000,
    },
    teachingInfo: {
      bellShedule: 'true',
      designation: 'Highschool',
      examPerdays: 7,
      teachingGrades: [8, 9, 10, 11, 12],
      teachingSubject: [1, 2, 3, 4, 5, 6, 7, 8],
      schoolBellScheduleId: 22,
      teachingSubjectcount: 8,
    },
    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: 665422042000,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: null,
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,
      school_periods: [
        {
          day: 'monday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'tuesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'wednesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'thursday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'friday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
      ],
      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
  },
  {
    id: 3761,
    created_at: 1707075287000,
    firstName: 'Lily',
    lastName: 'Doe',
    email: 'lily.d@teacher.com',
    school_indentity_number: 'ii7WLQQa',
    role_id: 9,
    school_id: 47,
    isNewUser: false,
    isArchived: false,
    profileData: {
      dateOfHire: 1707157800000,
      currentRoute: '/administration',
      tbClearanceDate: 1706812200000,
      tbExpirationDate: 1832956200000,
      credentialDocumentNumber: 'a154564156454',
      credentialExpirationDate: 1709145000000,
      credentialTypeEmployment: 'None',
      dateOfCriminalBackground: 1559606400000,
    },
    teachingInfo: {
      bellShedule: 'true',
      designation: 'Highschool',
      examPerdays: 6,
      teachingGrades: [8, 9, 10, 11, 12, 13, 14],
      teachingSubject: [1, 2, 3, 4, 5, 6, 7],
      schoolBellScheduleId: 105,
      teachingSubjectcount: 7,
    },
    user_profile_media_id: 0,
    contact: 4569871256,
    address: '',
    birthdate: 634242600000,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: null,
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,
      school_periods: [
        {
          day: 'monday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'tuesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'wednesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'thursday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'friday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
      ],
      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
  },
  {
    id: 3764,
    created_at: 1704279063192,
    firstName: 'jason',
    lastName: 'ray',
    email: 'jason.ray@gmail.com',
    school_indentity_number: 'MaVj21bq',
    role_id: 18,
    school_id: 47,
    isNewUser: false,
    isArchived: true,
    profileData: {
      grades: 11,
      parentEmail: null,
      studentCode: 'jut0TD',
      currentRoute: 'dashboard/student-dashboard',
    },
    teachingInfo: '',
    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: null,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: null,
    role: {
      id: 18,
      created_at: 1669135171501,
      name: 'Student',
    },
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,
      school_periods: [
        {
          day: 'monday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'tuesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'wednesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'thursday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'friday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
      ],
      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
  },
  {
    id: 3737,
    created_at: 1698935925926,
    firstName: 'Kevin',
    lastName: 'Mac',
    email: 'kevin.m@teacher.com',
    school_indentity_number: 'kevin12342',
    role_id: 9,
    school_id: 47,
    isNewUser: false,
    profileData: {
      dateOfHire: 1699948800000,
      currentRoute: '/test-quizzes',
      tbClearanceDate: 1698908400000,
      tbExpirationDate: 1825138800000,
      credentialDocumentNumber: '3982983898',
      credentialExpirationDate: 1699344000000,
      credentialTypeEmployment: 'Teacher',
      dateOfCriminalBackground: 1699516800000,
    },
    teachingInfo: {
      bellShedule: 'true',
      designation: 'Highschool',
      examPerdays: 9,
      teachingGrades: [8, 9, 10, 11, 12, 13, 14],
      teachingSubject: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 18, 19, 20, 21, 22,
        23, 24, 25, 26, 27,
      ],
      schoolBellScheduleId: 105,
      teachingSubjectcount: 25,
    },
    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: 1572591600000,
    isDisable: true,
    is_logged_in: false,
    is_trial_user: null,
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,
      school_periods: [
        {
          day: 'monday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'tuesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'wednesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'thursday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'friday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
      ],
      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
  },
  {
    id: 3722,
    created_at: 1698648723966,
    firstName: 'D',
    lastName: 'Smith',
    email: 'd.s@admin.com',
    school_indentity_number: '779523123154',
    role_id: 12,
    school_id: 47,
    isNewUser: false,
    profileData: {
      currentRoute: '/administration',
      isManageUsers: true,
      isTeacherView: true,
      selectedSchools: [47],
      isViewMultipleSchools: true,
    },
    teachingInfo: '',
    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: 66421800000,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: null,
    role: {
      id: 12,
      created_at: 1667469923135,
      name: 'Vice Principal',
    },
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,
      school_periods: [
        {
          day: 'monday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'tuesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'wednesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'thursday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'friday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
      ],
      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
  },
  {
    id: 3718,
    created_at: 1698342379962,
    firstName: 'Harris',
    lastName: 'Doe',
    email: 'harris.doe@teacher.com',
    school_indentity_number: 'harry1243',
    role_id: 9,
    school_id: 47,
    isNewUser: false,
    profileData: {
      dateOfHire: '2023-04-17',
      currentRoute: '/administration',
      tbClearanceDate: '2023-10-09',
      tbExpirationDate: '2027-10-09',
      credentialDocumentNumber: '347288',
      credentialExpirationDate: '2023-10-26',
      credentialTypeEmployment: 'Teacher',
      dateOfCriminalBackground: '2023-03-28',
    },
    teachingInfo: '',
    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: 816508800000,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: null,
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,
      school_periods: [
        {
          day: 'monday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'tuesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'wednesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'thursday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'friday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
      ],
      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
  },
  {
    id: 3716,
    created_at: 1698301404760,
    firstName: 'Geo',
    lastName: 'Doe',
    email: 'geo.deo@student.com',
    school_indentity_number: '231312312321',
    role_id: 18,
    school_id: 47,
    isNewUser: false,
    profileData: {
      grades: 3,
      parentEmail: null,
      studentCode: 'rcDtyw',
    },
    teachingInfo: '',
    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: 950688000000,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: null,
    role: {
      id: 18,
      created_at: 1669135171501,
      name: 'Student',
    },
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,
      school_periods: [
        {
          day: 'monday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'tuesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'wednesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'thursday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'friday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
      ],
      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
  },
  {
    id: 3702,
    created_at: 1698229943692,
    firstName: 'Maria',
    lastName: 'Alex',
    email: 'maria.a@student.com',
    school_indentity_number: '456987123654',
    role_id: 18,
    school_id: 47,
    isNewUser: false,
    profileData: {
      grades: 6,
      parentEmail: null,
      studentCode: 'wraKM2',
    },
    teachingInfo: '',
    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: 1545244200000,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: null,
    role: {
      id: 18,
      created_at: 1669135171501,
      name: 'Student',
    },
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,
      school_periods: [
        {
          day: 'monday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'tuesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'wednesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'thursday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'friday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
      ],
      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
  },
  {
    id: 3701,
    created_at: 1698229189195,
    firstName: 'William',
    lastName: 'Sam',
    email: 'william.s@student.com',
    school_indentity_number: '789654123687',
    role_id: 18,
    school_id: 47,
    isNewUser: false,
    profileData: {
      grades: 8,
      parentEmail: null,
      studentCode: 'Q0sjlU',
    },
    teachingInfo: '',
    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: 1167676200000,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: null,
    role: {
      id: 18,
      created_at: 1669135171501,
      name: 'Student',
    },
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,
      school_periods: [
        {
          day: 'monday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'tuesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'wednesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'thursday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'friday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
      ],
      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
  },
  {
    id: 3700,
    created_at: 1698226079436,
    firstName: 'Peter',
    lastName: 'England',
    email: 'peter.e@student.com',
    school_indentity_number: '785412365236',
    role_id: 18,
    school_id: 47,
    isNewUser: false,
    profileData: {
      grades: 7,
      parentEmail: null,
      studentCode: '3U61QE',
    },
    teachingInfo: '',
    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: 1201113000000,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: null,
    role: {
      id: 18,
      created_at: 1669135171501,
      name: 'Student',
    },
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,
      school_periods: [
        {
          day: 'monday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'tuesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'wednesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'thursday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'friday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
      ],
      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
  },
];

export const UPCOMING_EVENTS: any[] = [
  {
    id: 126,
    created_at: 1706009018436,
    start: new Date(new Date().getFullYear(), new Date().getMonth(), 7),
    end: new Date(new Date().getFullYear(), new Date().getMonth(), 7),
    view_users: [3716, 3669, 249],
    title: 'LA Learning Fest',
    school_id: 47,
    user_id: 234,
    cssClass: 'green-event-content',
    color: {
      primary: '#49debb',
      secondary: '#49debb',
    },
    isDummy: true
  },
  {
    id: 125,
    created_at: 1706009018436,
    start: new Date(new Date().getFullYear(), new Date().getMonth(), 9),
    end: new Date(new Date().getFullYear(), new Date().getMonth(), 9),
    view_users: [3716, 3669, 249],
    title: 'NorCal Math Olympiad',
    school_id: 47,
    user_id: 234,
    cssClass: 'green-event-content',
    color: {
      primary: '#ffbc6e',
      secondary: '#ffbc6e',
    },
    isDummy: true
  },

  {
    id: 128,
    created_at: 1706015601270,
    start: new Date(new Date().getFullYear(), new Date().getMonth(), 13),
    end: new Date(new Date().getFullYear(), new Date().getMonth(), 13),
    view_users: [3669, 249],
    title: 'Academic Achievers Awards Night',
    school_id: 47,
    user_id: 234,
    cssClass: 'blue-event-content',
    color: {
      primary: '#63baf8',
      secondary: '#63baf8',
    },
    isDummy: true

  },
  {
    id: 129,
    created_at: 1706015605140,
    start: new Date(new Date().getFullYear(), new Date().getMonth(), 17),
    end: new Date(new Date().getFullYear(), new Date().getMonth(), 17),
    view_users: [3669, 249],
    title: 'Malibu Math Magic Night',
    school_id: 47,
    user_id: 234,
    cssClass: 'purple-event-content',
    color: {
      primary: '#ad6ff3',
      secondary: '#ad6ff3',
    },
    isDummy: true

  },

  {
    id: 132,
    created_at: 1706015657554,
    start: new Date(new Date().getFullYear(), new Date().getMonth(), 23),
    end: new Date(new Date().getFullYear(), new Date().getMonth(), 23),
    view_users: [3669, 249],
    title: 'Central Coast Coding Challenge',
    school_id: 47,
    user_id: 234,
    cssClass: 'blue-event-content',
    color: {
      primary: '#63baf8',
      secondary: '#63baf8',
    },
    isDummy: true

  },

  {
    id: 140,
    created_at: 1706015939812,
    start: new Date(new Date().getFullYear(), new Date().getMonth(), 25),
    end: new Date(new Date().getFullYear(), new Date().getMonth(), 25),
    view_users: [3669, 249],
    title: 'first event test',
    school_id: 47,
    user_id: 234,
    cssClass: 'yellow-event-content',
    color: {
      primary: '#ffbc6e',
      secondary: '#ffbc6e',
    },
    isDummy: true

  },
  {
    id: 126,
    created_at: 1706009628338,
    start: new Date(new Date().getFullYear(), new Date().getMonth(), 26),
    end: new Date(new Date().getFullYear(), new Date().getMonth(), 26),
    view_users: [3716, 249],
    title: 'Hollywood High Talent Show',
    school_id: 47,
    user_id: 234,
    cssClass: 'blue-event-content',
    color: {
      primary: '#63baf8',
      secondary: '#63baf8',
    },
    isDummy: true

  },
];

export const ROLES = [
  {
    id: 17,
    created_at: 1667469964900,
    name: 'CAO(Chief Academic Officer)',
  },
  {
    id: 16,
    created_at: 1667469957361,
    name: 'CBO(Chief Business Officer)',
  },
  {
    id: 15,
    created_at: 1667469948902,
    name: 'COO(Chief Operating Officer)',
  },
  {
    id: 2,
    created_at: 1667469847414,
    name: 'Cafeteria Staff',
  },
  {
    id: 14,
    created_at: 1667469940859,
    name: 'Executive Director',
  },
  {
    id: 1,
    created_at: 1667469840114,
    name: 'Maintenance',
  },
  {
    id: 6,
    created_at: 1667469875178,
    name: 'Office Manager',
  },
  {
    id: 5,
    created_at: 1667469868262,
    name: 'Office Staff',
  },
  {
    id: 20,
    created_at: 1688538874238,
    name: 'Parent',
  },
  {
    id: 13,
    created_at: 1667469931525,
    name: 'Principal',
  },
  {
    id: 8,
    created_at: 1667469892287,
    name: 'RSP Teacher',
  },
  {
    id: 11,
    created_at: 1667469915604,
    name: 'SPED Coordinator',
  },
  {
    id: 10,
    created_at: 1667469907688,
    name: 'SPED Support Staff',
  },
  {
    id: 7,
    created_at: 1667469882698,
    name: 'Speech Therapist',
  },
  {
    id: 18,
    created_at: 1669135171501,
    name: 'Student',
  },
  {
    id: 19,
    created_at: 1670914624414,
    name: 'Super Admin',
  },
  {
    id: 4,
    created_at: 1667469861711,
    name: 'Support Staff',
  },
  {
    id: 9,
    created_at: 1667469900363,
    name: 'Teacher',
  },
  {
    id: 3,
    created_at: 1667469854475,
    name: "Teacher's Assistant",
  },
  {
    id: 12,
    created_at: 1667469923135,
    name: 'Vice Principal',
  },
];

export const ADMIN_EVENT_USER = [
  {
    id: 1666,
    created_at: 1697005224590,
    firstName: 'Jenny',
    lastName: 'Smith',
    email: 'jenny@student.com',
    school_indentity_number: '0',
    role_id: 18,
    school_id: 47,
    isNewUser: true,
    profileData: {},
    teachingInfo: {},
    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: null,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: null,
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,
      school_periods: [
        {
          day: 'monday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'tuesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'wednesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'thursday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'friday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
      ],
      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
    role: {
      id: 18,
      created_at: 1669135171501,
      name: 'Student',
    },
  },
  {
    id: 849,
    created_at: 1693384368204,
    firstName: 'Nino',
    lastName: 'Saur',
    email: 'nino@parent.com',
    school_indentity_number: '4728578',
    role_id: 20,
    school_id: 47,
    isNewUser: false,
    profileData: {
      students: [],
      currentRoute: '/administration',
    },
    teachingInfo: '',
    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: null,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: null,
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,
      school_periods: [
        {
          day: 'monday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'tuesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'wednesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'thursday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'friday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
      ],
      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
    role: {
      id: 20,
      created_at: 1688538874238,
      name: 'Parent',
    },
  },
  {
    id: 249,
    created_at: 1691065485514,
    firstName: 'Jeck',
    lastName: 'Jerry',
    email: 'jeck@teacher.com',
    school_indentity_number: '',
    role_id: 9,
    school_id: 47,
    isNewUser: false,
    profileData: {
      dateOfHire: 1691046000000,
      currentRoute: '/administration',
      tbClearanceDate: 1690959600000,
      tbExpirationDate: 1817190000000,
      credentialDocumentNumber: '2121873827777',
      credentialExpirationDate: 1692082800000,
      credentialTypeEmployment: 'teacher',
      dateOfCriminalBackground: 1690959600000,
    },
    teachingInfo: {
      bellShedule: 'true',
      designation: 'Highschool',
      examPerdays: 14,
      teachingGrades: [8, 9, 10, 12, 11, 13],
      teachingSubject: [7, 8, 6, 4, 5],
      teachingSubjectcount: 5,
    },
    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: 1557903600000,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: null,
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,
      school_periods: [
        {
          day: 'monday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'tuesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'wednesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'thursday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'friday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
      ],
      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },
  {
    id: 3761,
    created_at: 1707075287000,
    firstName: 'Lily',
    lastName: 'Churco',
    email: 'lily.c@teacher.com',
    school_indentity_number: 'ii7WLQQa',
    role_id: 9,
    school_id: 47,
    isNewUser: false,
    profileData: {
      dateOfHire: 1707157800000,
      currentRoute: '/administration',
      tbClearanceDate: 1706812200000,
      tbExpirationDate: 1832956200000,
      credentialDocumentNumber: 'a154564156454',
      credentialExpirationDate: 1709145000000,
      credentialTypeEmployment: 'None',
      dateOfCriminalBackground: 1559606400000,
    },
    teachingInfo: {
      bellShedule: 'true',
      designation: 'Highschool',
      examPerdays: 6,
      teachingGrades: [8, 9, 10, 11, 12, 13, 14],
      teachingSubject: [1, 2, 3, 4, 5, 6, 7],
      schoolBellScheduleId: 105,
      teachingSubjectcount: 7,
    },
    user_profile_media_id: 0,
    contact: 4569871256,
    address: '',
    birthdate: 634242600000,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: null,
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,
      school_periods: [
        {
          day: 'monday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'tuesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'wednesday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'thursday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
        {
          day: 'friday',
          periods: [
            {
              end: '2023-07-03T15:00:00.000Z',
              start: '2023-07-31T01:30:00.000Z',
              title: 'Homeroom',
            },
            {
              end: '2023-09-26T16:00:00.000Z',
              start: '2023-07-03T15:00:00.000Z',
              title: 'Period 1',
            },
          ],
        },
      ],
      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },
];

export const STUDENT_HELP_REQUEST = [
  {
    id: 238,
    created_at: 1698707166824,
    question:
      'A store sells two types of products, X and Y. The store wants to make at least $500 in sales. If the price of product X is $10 and the price of product Y is $20, write an inequality to represent this constraint.',
    student_extra_help_type_id: 3,
    students_notes_id: 0,
    assignment_questions_id: 941,
    from_user_id: 3724,
    to_user_id: [3727],
    status: 1,
    user_answer:
      "Yes! Check your notes but still it's easy: \nThe inequality to represent this constraint would be 10X + 20Y ≥ 500, where X represents the quantity of product X and Y represents the quantity of product Y.",
    classroom_id: 306,
    message: 'What?! Please help',
    from_time: 1698707163734,
    to_time: 1698784536816,
    from_user: {
      id: 3724,
      firstName: 'Johann',
      lastName: 'Bach',
      user_profile_media_id: 657,
      user_profile_media: {
        id: 657,
        created_at: 1698703357520,
        image: {
          access: 'public',
          path: '/uploads/user_profile_images/1774342528236-bach.jpg',
          name: 'bach.jpg',
          type: 'image',
          size: 60539,
          mime: 'image/jpeg',
          meta: {
            width: 1000,
            height: 750,
          },
          url: `${environment.XANO_SERVER_URL}/uploads/user_profile_images/1774342528236-bach.jpg`,
        },
      },
    },
    assignment_questions: [
      {
        id: 941,
        created_at: 1698700568986,
        content:
          'A store sells two types of products, X and Y. The store wants to make at least $500 in sales. If the price of product X is $10 and the price of product Y is $20, write an inequality to represent this constraint.',
        options: [[]],
        answer:
          'The inequality to represent this constraint would be 10X + 20Y ≥ 500, where X represents the quantity of product X and Y represents the quantity of product Y.',
        assignments_id: 378,
        assignment_type_id: 2,
        assignment_question_media_id: 0,
        user_id: 3723,
        assignment_option_media_images: [],
        substitute_teacher_user_id: 0,
      },
    ],
    respondedByUser: {
      id: 3727,
      firstName: 'Alexis',
      lastName: 'Juniper',
      user_profile_media_id: 658,
      user_profile_media: {
        id: 658,
        created_at: 1698703612984,
        image: {
          access: 'public',
          path: '/uploads/user_profile_images/1774342734581-alexis.jpg',
          name: 'alexis.jpg',
          type: 'image',
          size: 407040,
          mime: 'image/jpeg',
          meta: {
            width: 1080,
            height: 1440,
          },
          url:`${environment.XANO_SERVER_URL}/uploads/user_profile_images/1774342734581-alexis.jpg`,
        },
      },
    },
    classroom: {
      id: 306,
      name: '7th Grade',
    },
  },
  {
    id: 237,
    created_at: 1698707155413,
    question:
      'A landscaping company charges a flat fee of $100 for consultation plus $25 per hour of work. Write an equation to represent the total cost, C, for a consultation and d hours of work.2. A taxi service charges a flat fee of $5 for pickup plus $2.50 per mile driven. Write an equation to represent the total cost, C, for a ride of d miles.',
    student_extra_help_type_id: 3,
    students_notes_id: 0,
    assignment_questions_id: 945,
    from_user_id: 3724,
    to_user_id: [3727],
    status: 1,
    user_answer:
      'Yes check my solution below. Hope this helps! If not, just message me and we can try more\n\n\n\n2. For the taxi service, the total cost, C, is made up of a flat fee of $5 and the rate of $2.50 per mile. So, for a ride of d miles, the equation would be C = 5 + 2.50d.',
    classroom_id: 306,
    message:
      "I Don't get how to solve this did we even learn it lol someone help!",
    from_time: 1698707152331,
    to_time: 1698784570439,
    from_user: {
      id: 3724,
      firstName: 'Johann',
      lastName: 'Bach',
      user_profile_media_id: 657,
      user_profile_media: {
        id: 657,
        created_at: 1698703357520,
        image: {
          access: 'public',
          path: '/uploads/user_profile_images/1774342528236-bach.jpg',
          name: 'bach.jpg',
          type: 'image',
          size: 60539,
          mime: 'image/jpeg',
          meta: {
            width: 1000,
            height: 750,
          },
          url: `${environment.XANO_SERVER_URL}/uploads/user_profile_images/1774342528236-bach.jpg`,
        },
      },
    },
    assignment_questions: [
      {
        id: 945,
        created_at: 1698700681837,
        content:
          'A landscaping company charges a flat fee of $100 for consultation plus $25 per hour of work. Write an equation to represent the total cost, C, for a consultation and d hours of work.2. A taxi service charges a flat fee of $5 for pickup plus $2.50 per mile driven. Write an equation to represent the total cost, C, for a ride of d miles.',
        options: [[]],
        answer:
          '1. For the landscaping company, the total cost, C, is made up of a flat fee of $100 and the hourly rate of $25. So, for d hours of work, the equation would be C = 100 + 25d.\n\n2. For the taxi service, the total cost, C, is made up of a flat fee of $5 and the rate of $2.50 per mile. So, for a ride of d miles, the equation would be C = 5 + 2.50d.',
        assignments_id: 378,
        assignment_type_id: 2,
        assignment_question_media_id: 0,
        user_id: 3723,
        assignment_option_media_images: [],
        substitute_teacher_user_id: 0,
      },
    ],
    respondedByUser: {
      id: 3727,
      firstName: 'Alexis',
      lastName: 'Juniper',
      user_profile_media_id: 658,
      user_profile_media: {
        id: 658,
        created_at: 1698703612984,
        image: {
          access: 'public',
          path: '/uploads/user_profile_images/1774342734581-alexis.jpg',
          name: 'alexis.jpg',
          type: 'image',
          size: 407040,
          mime: 'image/jpeg',
          meta: {
            width: 1080,
            height: 1440,
          },
          url: `${environment.XANO_SERVER_URL}/uploads/user_profile_images/1774342734581-alexis.jpg`,
        },
      },
    },
    classroom: {
      id: 306,
      name: '7th Grade',
    },
  },
  {
    id: 198,
    created_at: 1695803382763,
    question:
      'Who were some famous explorers, and what new lands did they find?',
    student_extra_help_type_id: 3,
    students_notes_id: 0,
    assignment_questions_id: 719,
    from_user_id: 236,
    to_user_id: [274, 1392, 1393],
    status: 1,
    user_answer:
      "Famous explorers include Christopher Columbus, who is known for discovering the Americas in 1492, and Ferdinand Magellan, who led the first expedition to circumnavigate the globe in the early 16th century. Columbus's voyages opened up the New World to European exploration, while Magellan's journey proved that the Earth is round.\nthese are some famour explorers.",
    classroom_id: 286,
    message: 'Please tell me about famous explorers',
    from_time: 1695803382322,
    to_time: 1695803410097,
    from_user: {
      id: 236,
      firstName: 'Ashleigh',
      lastName: 'Mack',
      user_profile_media_id: 0,
    },
    assignment_questions: [
      {
        id: 719,
        created_at: 1695292284598,
        content:
          'Who were some famous explorers, and what new lands did they find?',
        options: [[]],
        answer:
          "Famous explorers include Christopher Columbus, who is known for discovering the Americas in 1492, and Ferdinand Magellan, who led the first expedition to circumnavigate the globe in the early 16th century. Columbus's voyages opened up the New World to European exploration, while Magellan's journey proved that the Earth is round.",
        assignments_id: 309,
        assignment_type_id: 2,
        assignment_question_media_id: 0,
        user_id: 235,
        assignment_option_media_images: [],
        substitute_teacher_user_id: 0,
      },
    ],
    respondedByUser: {
      id: 274,
      firstName: 'Merry',
      lastName: 'Code',
      user_profile_media_id: 0,
    },
    classroom: {
      id: 286,
      name: 'History Classroom',
    },
  },
  {
    id: 197,
    created_at: 1695803314790,
    question:
      'Who is the inventor you chose, and why did you find them interesting?',
    student_extra_help_type_id: 3,
    students_notes_id: 0,
    assignment_questions_id: 720,
    from_user_id: 236,
    to_user_id: [274, 275, 1392],
    status: 1,
    user_answer:
      'I chose Thomas Edison because he is one of the most famous American inventors, and I find his work fascinating. His inventions have had a significant impact on our daily lives, and I wanted to learn more about him.\nThis should be our answer.',
    classroom_id: 286,
    message: 'Please help me with this',
    from_time: 1695803314318,
    to_time: 1695803344266,
    from_user: {
      id: 236,
      firstName: 'Ash',
      lastName: 'Johnson',
      user_profile_media_id: 0,
    },
    assignment_questions: [
      {
        id: 720,
        created_at: 1695292297156,
        content:
          'Who is the inventor you chose, and why did you find them interesting?',
        options: [[]],
        answer:
          'I chose Thomas Edison because he is one of the most famous American inventors, and I find his work fascinating. His inventions have had a significant impact on our daily lives, and I wanted to learn more about him.',
        assignments_id: 308,
        assignment_type_id: 2,
        assignment_question_media_id: 0,
        user_id: 235,
        assignment_option_media_images: [],
        substitute_teacher_user_id: 0,
      },
    ],
    respondedByUser: {
      id: 274,
      firstName: 'Merry',
      lastName: 'Code',
      user_profile_media_id: 0,
    },
    classroom: {
      id: 286,
      name: 'History Classroom',
    },
  },
];
